import { useState } from 'react'

import { AnimateBox } from '../../components/animate-box'

import type { PageContent } from '../../pageContents'
interface SectionAProps {
  data: PageContent[]
  title: string
}
export const SectionA = ({ data, title }: SectionAProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          取得ISO
          26262认证，覆盖系统开发的全生命周期，高效易用、软硬结合、仿测一体，打造一体化工具链
        </AnimateBox>
      </div>

      <ul className='wrap'>
        {data.map((item, index) => {
          const key = index + '1'
          const classArr = ['card', 'h600']
          if (index === activeIndex) {
            classArr.push('w690')
          } else {
            classArr.push('w345')
          }
          classArr.push('p335-180')
          return (
            <AnimateBox
              animateDelay={(index % 4) * 0.2}
              className={classArr.join(' ')}
              key={key}
              onMouseEnter={() => {
                setActiveIndex(index)
              }}
            >
              <div className='img h348'>
                <div className='pic' style={{ backgroundImage: `url(${item.thumbnail})` }} />
              </div>
              <h5 className='clamp-2'>
                <a href={`/products/${item.id}`}>{item.name}</a>
              </h5>
              <p className='clamp-3'>{item.descriptions}</p>
              <a className='look-more' href={`/products/${item.id}`}>
                了解更多
              </a>
            </AnimateBox>
          )
        })}
      </ul>
    </>
  )
}
